// extracted by mini-css-extract-plugin
export default {"org--identity":"OrgChart_org--identity__bi-9+"};